// One colour per UTC offset, shared by the zone fills and the city
// offset tags.
//
// Whole hours: a seven-step pastel cycle — peach, butter, sage, mint,
// powder blue, lavender, blush — one step per hour, so neighbouring
// zones never share a colour.
//
// Half and quarter hours (India, Iran, Nepal, Myanmar, Newfoundland,
// central Australia, Eucla, Chatham…): a deeper accent taken from the
// far side of the cycle — four steps on for :30, two for :45 — so the
// zone stands apart from the whole-hour zones on either side of it
// (Eucla +8:45 is teal between Perth's butter and Adelaide's rose).
const PASTELS: [number, number, number][] = [
  [247, 200, 181], // peach
  [246, 227, 161], // butter
  [207, 230, 194], // sage
  [185, 224, 220], // mint
  [195, 212, 242], // powder blue
  [217, 203, 240], // lavender
  [242, 201, 220], // blush
];

// The dark theme mutes the colours toward this night slate.
const NIGHT_SLATE: [number, number, number] = [28, 34, 48];

const mod = (n: number, m: number) => ((n % m) + m) % m;
const mix = (a: number[], b: number[], t: number) => a.map((v, i) => v + (b[i] - v) * t);

// A pastel made deeper: more saturated, a little darker.
function deepen(c: number[]): number[] {
  const mean = (c[0] + c[1] + c[2]) / 3;
  return c.map((v) => Math.min(255, Math.max(0, (mean + (v - mean) * 2.2) * 0.93)));
}

/** Zone colour as [r, g, b] 0–255; theme 1 = light, 0 = dark. */
export function zoneColor(offsetMinutes: number, theme = 1): [number, number, number] {
  const hour = Math.floor(offsetMinutes / 60);
  const minutes = mod(offsetMinutes, 60);
  const c =
    minutes === 0
      ? PASTELS[mod(hour, 7)]
      : deepen(PASTELS[mod(hour + (minutes === 45 ? 2 : 4), 7)]);
  const out = theme > 0.5 ? c : mix(c, NIGHT_SLATE, 0.45);
  return out.map(Math.round) as [number, number, number];
}
